import { render, staticRenderFns } from "./OrderShippingInfoModal.vue?vue&type=template&id=64cfdb36&scoped=true"
import script from "./OrderShippingInfoModal.vue?vue&type=script&lang=js"
export * from "./OrderShippingInfoModal.vue?vue&type=script&lang=js"
import style0 from "./OrderShippingInfoModal.vue?vue&type=style&index=0&id=64cfdb36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cfdb36",
  null
  
)

export default component.exports